<template>
  <Starfield>
    <iRow vertical-align="middle" align="center">
      <iColumn align="center" :width="600">
        <iSpace :height="40" />
        <iHeading variant="error" font-size="displayLarge">
          App authorization failed
        </iHeading>
        <iSpace :height="16" />
        <iText font-size="medium" variant="error">
          {{ humanMessage }}
        </iText>
        <iSpace :height="24" />
        <iRow width="hug" align="center">
          <iButton variant="secondary" @click="goHome">
            Back to q3po
          </iButton>
        </iRow>
      </iColumn>
    </iRow>
  </Starfield>
</template>

<script>
import Starfield from "@/components/Starfield";

const REASON_MESSAGES = {
  unknown_app_token: "The app trying to authenticate did not present a valid app token. If you got here from a third-party tool, it may be misconfigured.",
};

export default {
  name: "AppAuthError",
  components: { Starfield },
  props: {
    reason: { type: String, required: true },
  },
  computed: {
    humanMessage() {
      return REASON_MESSAGES[this.reason] ?? "Something went wrong authorizing the app.";
    },
  },
  methods: {
    goHome() {
      window.location.href = "/";
    },
  },
};
</script>
